import React from "react";
import Select from 'react-select'

const CategoryDropdownScores = ({ selectHandler, value }) => {
  const types = [
    {"label":"AccuracyScore", "value" : "AccuracyScore"}, 
    {"label": "FluencyScore", "value": "FluencyScore"},
    {"label":"CompletenessScore",  "value":"CompletenessScore"}, 
    {"label": "PronScore", "value":"PronScore"}
  ];
  
  // Find the current value in the options
  const currentValue = value ? types.find(option => option.value === value) : types[0];

  return (
    <Select  
      onChange={selectHandler}
      options={types}
      value={currentValue}
      className="text-sm"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '44px',
          borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
          borderRadius: '8px',
          backgroundColor: 'white',
          boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
          '&:hover': {
            borderColor: state.isFocused ? '#3b82f6' : '#9ca3af'
          },
          transition: 'all 0.2s ease-in-out'
        }),
        menu: (base) => ({
          ...base,
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          zIndex: 50
        })
      }}
    />
  );
};

export default CategoryDropdownScores;